const filtersModule = {
    namespaced: true,
    state: {
      filters: [],
      materialType: "mtCell",
      phenotypeCompliance: null,
    },
    getters: {
      getMaterialType(state) {
        return state.materialType
      },
      getFilters(state) {
        return state.filters
      },
      getSelectedValueByField: (state) => (field) => {
        let selected = state.filters.find(filter => filter.field === field);
        return selected ? selected.value : [];
      },
      getSelectedRangeByField: (state) => (field) => {
        let selectedRange = state.filters.find(filter => filter.field === field);
        return selectedRange ? [selectedRange.value.gte, selectedRange.value.lte] : [0, 0];
      },
      getSelectedMinRangeByField: (state, getters) => (field) => {
        return getters.getSelectedRangeByField(field)[0] 
      },
      getSelectedMaxRangeByField: (state, getters) => (field) => {
        return getters.getSelectedRangeByField(field)[1] 
      },
      getPhenotypeCompliance(state) {
        return state.phenotypeCompliance
      },
    },
    actions: {
      setFilters({commit}, filters) {
        commit('setFilters', filters);
      },
      setMaterialType({commit}, materialType) {
        commit('setMaterialType', materialType);
      },
      setPhenotypeCompliance({commit}, phenotypeCompliance) {
        commit('setPhenotypeCompliance', phenotypeCompliance);
      },
      clearFilters({commit}) {
        commit('setFilters', []);
      },
      clearPhenotypeCompliance({commit}) {
        commit('setPhenotypeCompliance', null);
      },
    },
    mutations: {
      setFilters(state, filters) {
        state.filters = filters;
      },
      setMaterialType(state, materialType) {
        state.materialType = materialType;
      },
      setPhenotypeCompliance(state, phenotypeCompliance) {
        state.phenotypeCompliance = phenotypeCompliance;
      },
    }
  }

  export default filtersModule;